<template>
    <div class="row issue-form">

            <!--<div class="col s3" v-if="steps == 0">
                <h4>Templates</h4>
                <div class="row">
                    <div class="col s12" v-for="(template, index) in issue_templates">
                        <div class="card-panel template-cont hoverable" v-on:click="templateClick(template)">
                            <img class="responsive-img" :src="imgExample">
                            <div class="template-title center-align">test title</div>
                        </div>
                    </div>
                </div>
            </div>-->
        <div class="col s12">
            <div class="row" v-if="edit">
                <div class="col s8">
                    <h3 class="truncate">Issue - {{ name ? name : createdAtDate }}</h3>
                    <div class="date">
                        Created At: {{ createdAtDate }}
                    </div>
                    <div class="date">
                        Updated At: {{ updatedAtDate }}
                    </div>
                </div>
                <div class="col s4">
                    <div class="row" style="margin-top: 25px">
                        <div class="input-field col s12">
                            <select v-model="status" @change="changeStatus()">
                                <option value="1">Ongoing</option>
                                <option value="2">Completed</option>
                                <!--option value="3">Incomplete</option-->
                            </select>
                            <label>Mark as</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-if="!edit">
                <div class="col s12">
                    <div class="row">
                        <div class="input-field col s12 m4 l4 xl4">
                            <select v-model="selected_category" required>
                                <option value="" disabled selected>Choose your option</option>
                                <option v-for="(category, index) in issue_categories" :value="category.id">{{ category.title }}</option>
                            </select>
                            <label>Issue Categories</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
            <div class="col s12" v-bind:class="[steps == 0 ? 's9' : 's12']">
                <!--<h4 v-if="!edit">{{ month }}'s Issue</h4>-->
                <div class="card-panel">
                    <div class="row">

                        <div class="col s12">

                            <!--<div v-if="steps == 0">

                                <p>This wizard will guide you through a series of questions, please provide your answers for each questions.</p>
                                <p>
                                    <button class="btn btn-waves" v-on:click="incrementSteps">Get started</button>
                                </p>
                            </div>-->

                            <div v-for="(question, index) in issue_questions" v-show="(steps) == index">
                                <h4>{{ question.title }}...</h4>
                                <p v-if="question.description">{{ question.description }}</p>
                                <editor api-key="2xzlzxiqn5xk26l0g9wgi39r8n2kdr7u2wmm65a1usnvyrry" :init="{
                                    menubar:false,
                                    height: 250,
                                    plugins: 'preview searchreplace autolink directionality visualblocks visualchars fullscreen link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists textcolor wordcount imagetools contextmenu colorpicker textpattern help',
                                    toolbar: 'bold italic sizeselect fontsizeselect | hr alignleft aligncenter alignright alignjustify | bullist numlist | insertfile undo redo | forecolor',
                                    fontsize_formats: '8pt 10pt 12pt 14pt 18pt 24pt 36pt'
                                 }" class="materialize-textarea" v-model="answers[index].answer"></editor>
                                <p class="right-align">
                                    <a href="#" v-if="steps != 0" v-on:click.prevent="decrementSteps">Back</a>&nbsp;&nbsp

                                    <button v-if="(steps) != (issue_questions.length - 1)"
                                            :disabled="!answers[index].answer"
                                            class="waves-effect waves-light btn" v-on:click="incrementSteps">
                                        Next
                                    </button>

                                    <button v-bind:class="{'disabled': saving}"
                                            v-bind:disabled="saving"
                                            v-if="(steps) == (issue_questions.length - 1)" class="waves-effect waves-light btn"
                                            v-on:click="save" style="background-color: #c0a375">Save</button>
                                </p>
                            </div>
                        </div>

                    </div><!--/.row-->
                </div>
            </div>
    </div>
</template>

<script>
  import axios from 'axios';
  import Editor from '@tinymce/tinymce-vue';

  export default {
    name: 'IssueQuestionAnswerForm',

    props: {
      edit: String,
      editData: String,
      questions: String,
      issueCategories: String,
      templates: String,
      month: String,
      actionUrl: String,
      successUrl: String,
      editUrl: String,
      exampleImg: String,
      getChosenTemplateUrl: String,
      changeUrl: String,
      createdAtDate:String,
      updatedAtDate: String,
    },
    components : {
        'editor' : Editor
    },

    data() {
      return {
        saving: false,
        steps : 0,
        issue_questions: [],
        issue_templates: [],
        issue_categories: [],
        answers: [],
        imgExample: '',
        template_selected: null,
        is_template_disable: false,
        name: '',
        selected_category: '',
        status: 0
      }
    },

    mounted() {
        var me = this;
        this.issue_questions = JSON.parse(this.questions); // questions are passed from argument

        if(this.edit !== "1") {
            this.issue_templates = JSON.parse(this.templates);
            this.issue_categories = JSON.parse(this.issueCategories); // issue categories are passed from argument
        }

      this.imgExample = this.exampleImg;

      if(this.edit === "1") {
        var answers_json = JSON.parse(this.editData);
        this.name = answers_json.name;
        this.status = answers_json.status;
        this.answers = answers_json.answers;
        //this.steps++;

      } else {
        this.issue_questions.forEach((question) => {
          this.answers.push({question_id: question.id, answer: null });
        });
      }

    },

    methods: {

      /**
       * Saves the form
       * */
      save() {

        if(!this.check()) return false; // check all answers are filled first

        this.saving = !this.saving;
        M.toast({html: 'Saving...', classes: 'saving_toast'});
        let savingToastInstance = M.Toast.getInstance(document.querySelector('.saving_toast'));

        let url = (this.edit === "1") ? this.editUrl : this.actionUrl;
        let data =  {
          'id'      : (this.edit === "1") ? this.answers[0]['issue_group_id'] : null,
          'issue_category'    : (this.edit === "1") ? '' : this.selected_category,
          'status'  : (this.edit === "1") ? this.status  : 1,
          'answers' : this.answers
        };

        // axios Save to server
        axios.post(url, data).then(response => {

          savingToastInstance.dismiss();
          this.saving = !this.saving;

          if(response.data.success) {
            M.toast({html:  response.data.messages, classes: 'toast-background-color'});
            window.location.href = this.successUrl;
          } else {
            M.toast({html: 'Error, ' + response.data.messages, classes: 'red accent-2'});
          }

        }).catch(err => {

          savingToastInstance.dismiss();
          this.saving = !this.saving;
          let errorMsg = err.response.data.errors;
          let errorList = '';
          $.each(errorMsg, function(idx, value) {
            errorList += '</br> - '+value
          });
          M.toast({html: 'Create Failed.' + err, classes: 'red accent-2', displayLength: 5000});


        });
      },

      /**
       * Check the form inputs
       * @returns {boolean}
       */
      check() {

        let success = true;
        this.answers.forEach((answer) => {
            if(!answer.answer) { // if not filled
                success = false;
            }
        });

        if(!success) M.toast({html: 'Please answer all questions first', classes: 'red accent-2'});

        if (!this.selected_category && (this.edit !== "1")) {
          success = false;
          M.toast({html: 'Please select a category first', classes: 'red accent-2'});
        }

        return success;
      },

      /**
       * Increment steps
       */
      incrementSteps() {
        if((this.steps) !== (this.issue_questions.length)) {
          this.steps++;
        }

        if (this.steps > 0)
        {
          this.is_template_disable = true;
        }
      },

      /**
       * Decrement steps
       */
      decrementSteps() {
        if(this.steps > 0) this.steps--;
      },

      templateClick(template) {
        var me = this;

        if (!this.is_template_disable) {
          this.is_template_disable = true;
          // axios get from server
          axios.post(this.getChosenTemplateUrl, {

            'template_id' : template.id

          }).then(response => {

            me.answers.forEach((answer) => {
              answer.answer = response.data;
            });
          }).catch(err => {

          });
        }
      },

      changeStatus() {
        if (confirm('Are you sure to update issue status?')) {
          // Save it!
          // axios Save to server
          let url =  this.changeUrl;

          this.saving = !this.saving;
          M.toast({html: 'Saving...', classes: 'saving_toast'});
          let savingToastInstance = M.Toast.getInstance(document.querySelector('.saving_toast'));
          let data =  {
            'id'      : (this.edit === "1") ? this.answers[0]['issue_group_id'] : null,
            'status'  : (this.edit === "1") ? this.status  : 1,
          };
          axios.post(url, data).then(response => {

            savingToastInstance.dismiss();
            this.saving = !this.saving;

            if(response.data.success) {
              M.toast({html:  response.data.messages, classes: 'toast-background-color'});
              window.location.href = this.successUrl;
            } else {
              M.toast({html: 'Error, ' + response.data.messages, classes: 'red accent-2'});
            }

          }).catch(err => {

            savingToastInstance.dismiss();
            this.saving = !this.saving;
            let errorMsg = err.response.data.errors;
            let errorList = '';
            $.each(errorMsg, function(idx, value) {
              errorList += '</br> - '+value
            });
            M.toast({html: 'Create Failed.' + err, classes: 'red accent-2', displayLength: 5000});


          });
        } else {
          // Do nothing!
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
    .template-cont {
        padding: 0;
        cursor: pointer;

        .template-title {
            padding: 5px 5px;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/issues/IssueQuestionAnswerForm.vue